<template>
  <div class="c-app flex-row align-items-center">
    <CContainer>
      <div class="container-box">
        <label style="text-align: left; left: 0" class="custom-label-note"
          >We’ve sent the verification code to {{ email }}</label
        >
        <br />
        <label style="text-align: left; left: 0" class="custom-label-note"
          >My Code is</label
        >
        <!-- <CRow class="justify-content-center mb-2">
          <CCol
            style="display: content; align-items: center; justify-content: center"
          >
            <CCol sm="12" lg="12" class="p-0">
                <CCol
                  sm="12"
                  lg="12"
                  class="p-0"
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                >
                  <CCol sm="2" lg="2" class="p-0 m-0" style="flex: 1">
                    <CCol>
                      <input
                        type="text"
                        class="custom-input-user input-responsive"
                      />
                    </CCol>
                  </CCol>

                  <CCol sm="2" lg="2" class="p-0 m-0" style="flex: 1">
                    <CCol>
                      <input
                        type="text"
                        class="custom-input-user input-responsive"
                      />
                    </CCol>
                  </CCol>
                  <CCol sm="2" lg="2" class="p-0 m-0" style="flex: 1">
                    <CCol>
                      <input
                        type="text"
                        class="custom-input-user input-responsive"
                      />
                    </CCol>
                  </CCol>

                  <CCol sm="2" lg="2" class="p-0 m-0" style="flex: 1">
                    <CCol>
                      <input
                        type="text"
                        class="custom-input-user input-responsive"
                      />
                    </CCol>
                  </CCol>
                    <CCol sm="2" lg="2" class="p-0 m-0" style="flex: 1">
                    <CCol>
                      <input
                        type="text"
                        class="custom-input-user input-responsive"
                      />
                    </CCol>
                  </CCol>
                    <CCol sm="2" lg="2" class="p-0 m-0" style="flex: 1">
                    <CCol>
                      <input
                        type="text"
                        class="custom-input-user input-responsive"
                      />
                    </CCol>
                  </CCol>
                </CCol>
            </CCol>
          </CCol>
        </CRow> -->

        <input type="number" v-model="otpCode" maxlength="6" />

        <br />
      </div>
    </CContainer>
    <div class="bottom-center">
    <label>Didn’t get the code?</label> 
    <br />
    
      <CButton color="info" class="custom-btn-login-active mt-2">
        Resend Code (59s)</CButton
      >

      <CButton color="info" class="custom-btn-login-active mt-2" @click="SubmitCode(otpCode)">
        Next</CButton
      >
    </div>
    <div class="header-top">Account Information</div>
    <div class="header-left" @click="GoBack()">
      <img src="../assets/img/icon/VectorLeft.svg" />
    </div>
    <div style="clear: both"></div>
  </div>
</template>


<script>
export default {
  name: "Login",
  e1: "#app",
  data: function () {
    return {
      email: this.$route.query.email,
      otpCode: "",
    };
  },
  async mounted() {},
  methods: {
    GoBack() {
     this.$router.back();
    },

    SubmitCode(otpCode) {
      const formData = new FormData();
      formData.append("userEmail", this.email);
      formData.append("code", otpCode);

      return this.$API
      .post(this.$ValidateForgotPasswordCode, formData, {
        withCredentials: true,
      })
      .then((response) => {
        if (response.status == 200) {
          this.Busy = false;
          // this.$dialog.alert("Successfully Update").then(function () {});
          this.GotoVerify(this.email, otpCode);
        } else {
          this.Busy = false;
          // this.$dialog.alert("Error to save").then(function () {});
        }
      })
      .catch((error) => {
        this.Busy = false;
        this.Loading = false;
        this.Error = true;
        this.Message = error.response.data.message;
      });
    },

    GotoVerify(email, code) {
    this.$router.push(
      "ResetPassword?email=" +
      email +
      "&code=" +
      code
    );
    },
  },
};
</script>


<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");
.c-app {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
}
body {
  font-family: "Montserrat", sans-serif;
}
.container-box {
  max-width: 335px;
  margin: 0 auto;
}

input {
  border-bottom: 2px solid #fff;
  background: none;
  border-top: none;
  border-left: none;
  border-right: none;
  width: inherit;
  color:#fff;
}
input .custom-user-input-select {
  border-bottom: 2px solid #fff;
  background: none;
  border-top: none;
  border-left: none;
  border-right: none;
}
.custom-width-listphone {
  width: 24px;
  height: 24px;

  flex: none;
  order: 0;
  flex-grow: 0;
}

select {
  border-bottom: 2px solid #fff;
  background: none;
  border-top: none;
  border-left: none;
  border-right: none;
  color: #e0e0e0;
}

input ::placeholder {
  color: #fff;
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #e0e0e0;
}
.custom-user-input {
  /* Body/1/Semibold */

  display: flex;
  justify-content: center;
  flex-flow: row nowrap;
}
.custom-user-input-select {
  /* Body/1/Semibold */

  display: flex;
  justify-content: center;
  flex-flow: row nowrap;
}
.custom-user-inputs {
  display: flex;
  display: -ms-flexbox;
  /* display: -webkit-box; */
  /* -webkit-box-pack: center; */
  -ms-flex-pack: center;
  justify-content: center;
  /* -webkit-box-orient: horizontal; */
  /* -webkit-box-direction: normal; */
  -ms-flex-flow: row nowrap;
  /* flex-flow: row nowrap; */
  width: -webkit-fill-available;
}

.custom-code {
  display: flex;
}
.custom-label-note{
    font-family: 'Montserrat';
font-style: normal;
font-weight: 500;
font-size: 16px;
line-height: 150%;
/* or 24px */

display: flex;
align-items: center;

/* Pure/White */

color: #FFFFFF;
}


</style>